import { ComponentTheme } from "hardcover-ui/types/base";

export type TabListThemeProps = {
  variant: "primary" | "secondary";
  size: "sm" | "md" | "lg";
};

export const tabListTheme: ComponentTheme<TabListThemeProps> = {
  variant: {
    primary: "border-b border-border mb-2",
    secondary: "mb-2",
  },
  size: {
    sm: "",
    md: "",
    lg: "",
  },
};

// const linkClass =
//   "font-medium font-semibold py-3 sm:py-4 px-1 border-b-2 whitespace-nowrap mr-2 sm:mr-8";
// const inactiveLinkClass =
//   "border-transparent text-gray-700 dark:text-gray-400 dark:hover:text-gray-600 dark:hover:border-gray-400 hover:border-gray-400";
// const activeLinkClass =
//   "font-bold border-indigo-300 text-indigo-500 dark:border-yellow-500 dark:text-yellow-50";

export type TabThemeProps = {
  variant: "primary" | "primarySelected" | "secondary" | "secondarySelected";
  size: "sm" | "md" | "lg";
};

const primary =
  "flex items-center font-semibold whitespace-nowrap leading-5 border-b-2 py-1 px-4 -mb-px";
const secondary =
  "flex items-center justify-center px-4 py-1.5 font-semibold whitespace-nowrap mb-1";

export const tabTheme: ComponentTheme<TabThemeProps> = {
  variant: {
    primary: `${primary} border-transparent text-muted-foreground hover:text-foreground hover:border-border`,
    primarySelected: `${primary} text-foreground border-primary`,
    secondary: `${secondary} bg-secondary rounded-full hover:bg-tertiary`,
    secondarySelected: `${secondary} bg-primary/10 hover:bg-primary/20 rounded-full`,
  },
  size: {
    sm: "text-sm",
    md: "text-base",
    lg: "text-base lg:text-lg py-1 md:py-3 sm:py-4 px-1 border-b-2 mr-1 md:mr-4",
  },
};
